import React from "react";
import ReactDOM from "react-dom/client";

import "assets/css/nucleo-icons.css";
import "react-notification-alert/dist/animate.css";
import "assets/scss/black-dashboard-pro-react.scss?v=1.2.0";
import "assets/css/wineappy-theme.css";
import "i18n";
import { ToastContainer } from "react-toastify";
import App from "App";
import UserContext from "context/UserContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <>
    <ToastContainer />
    <UserContext>
      <App />
    </UserContext>
  </>
);
